import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";
import {Header} from "../../layout/header/header";
import {getOfferedServices} from "../../models/Services/OfferedService";

@Component({
  selector: "app-offered-services-list",
  templateUrl: "./offered-services-list.html",
  styleUrl: "./offered-services-list.scss",
  imports: [
    Header,
    NgOptimizedImage,
  ],
})
export default class OfferedServicesList {
  protected readonly services = getOfferedServices();
}
